import React from "react";

const InviteButton = ({ onClick }) => {
  return (
    <button
      onClick={onClick}
      className="px-4 py-1 text-sm font-semibold rounded-full bg-black text-white hover:bg-neutral-800 transition duration-200"
    >
      Invite
    </button>
  );
};

export default InviteButton;
